<template>
<div class="chapter">
<div class="inner_page">
<p class="orna1"><a id="pii"></a><img alt="Williams" src="images/ornament.jpg"/></p>
<p class="series">THE LEWIS WALPOLE SERIES <br/>IN EIGHTEENTH-CENTURY CULTURE AND HISTORY</p>
<p class="series-t">The Lewis Walpole Series, published by Yale University Press with the aid of the Annie Burr Lewis Fund, is dedicated to the culture and history of the long eighteenth century (from the Glorious Revolution to the accession of Queen Victoria). It welcomes work in a variety of fields, including literature and history, the visual arts, political philosophy, music, legal history, and the history of science. In addition to original scholarly work, the series publishes new editions and translations of writing from the period, as well as reprints of major books that are currently unavailable. Though the majority of books in the series will probably concentrate on Great Britain and the Continent, the range of our geographical interests is as wide as Horace Walpole’s.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// lewis_walpole_series.vue?59304c7b